function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-email-campaign-signup-double\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.13,20.92H3.76a2.59,2.59,0,0,1-2.58-2.58V6.64A2.59,2.59,0,0,1,3.76,4.06h16.3a2.59,2.59,0,0,1,2.59,2.58v4.65a1,1,0,1,1-2.07,0V6.64a.51.51,0,0,0-.52-.51H3.76a.51.51,0,0,0-.51.51v11.7a.51.51,0,0,0,.51.51H9.13a1,1,0,1,1,0,2.07Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.42,34H11.61a3.39,3.39,0,0,1-3.39-3.39V13.56a3.39,3.39,0,0,1,3.39-3.39H35.42a3.4,3.4,0,0,1,3.4,3.39V30.65A3.4,3.4,0,0,1,35.42,34ZM11.61,12.42a1.14,1.14,0,0,0-1.14,1.14V30.65a1.14,1.14,0,0,0,1.14,1.14H35.42a1.15,1.15,0,0,0,1.15-1.14V13.56a1.15,1.15,0,0,0-1.15-1.14Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.65,33a1.13,1.13,0,0,1-.78-1.94l10.4-10a1.12,1.12,0,1,1,1.56,1.62l-10.4,10A1.13,1.13,0,0,1,9.65,33Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.39,33a1.1,1.1,0,0,1-.78-.32l-10.41-10a1.12,1.12,0,1,1,1.56-1.62l10.4,10A1.13,1.13,0,0,1,37.39,33Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.51,25a4.42,4.42,0,0,1-3-1.23L9.18,12.82a1.12,1.12,0,0,1,1.56-1.62L22.05,22.13a1.94,1.94,0,0,0,2.81,0L36.29,11.2a1.12,1.12,0,0,1,1.56,1.62L26.44,23.75A4.11,4.11,0,0,1,23.51,25Z",
  fill: "#231f20"
});

function SvgCmsEmailCampaignSignupDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgCmsEmailCampaignSignupDouble;